import _, { isNumber } from "lodash";
import { calDebtCreditCard, toFloat2 } from "../../utils/useFunctions";
import { useBalanceStore } from "../../_store/balanceStore";
import { key_under_education } from "../../pages/education/functions/options";
import { Education_Price } from "../../pages/report/constrant/constrant.main";

/**
 * แยกค่า default หนึ่งปีของข้อมูล legacy ออกจากระยะเวลาที่ผู้ใช้ตั้งเอง
 * โดย marker ทำให้ค่าหนึ่งปีเป็น explicit ส่วนค่า legacy ที่มากกว่าหนึ่งปี
 * ยังคงใช้ได้เพื่อรักษาข้อมูลเดิม กรณีอื่นให้หยุดรายรับที่อายุเกษียณ
 */
export const resolveExistingIncomeDuration = ({
  duration,
  isExplicit,
  ageCurrent,
  ageRetire,
}) => {
  const explicitDuration = Number(duration);
  const isUsableExplicitDuration =
    isExplicit === true && explicitDuration > 0;
  const isCompatibleLegacyDuration =
    isExplicit !== true && explicitDuration > 1;

  if (
    Number.isFinite(explicitDuration) &&
    (isUsableExplicitDuration || isCompatibleLegacyDuration)
  ) {
    return explicitDuration;
  }

  const retirementDuration = Number(ageRetire) - Number(ageCurrent);
  return Number.isFinite(retirementDuration) && retirementDuration > 0
    ? retirementDuration
    : 0;
};

export const Short_Term_Debt = (data, index, age) => {
  let allPeriods = [];
  let pay_sum_alls = Array.from({ length: age }).fill(0);

  for (const each_data of data?.short_terms || []) {
    let pay_periods = Array.from({ length: age }).fill(0);
    let period = Math.floor(each_data?.period / 12);
    let month_left = each_data?.period % 12;

    for (let item = 0; item < period; item++) {
      pay_periods[item] = each_data?.pay_permonth * 12;
      pay_sum_alls[item] += each_data?.pay_permonth * 12;
    }
    pay_periods[period] = each_data?.pay_permonth * month_left;
    pay_sum_alls[period] += each_data?.pay_permonth * month_left;

    allPeriods.push({ name: each_data?.creditor_name, pay_periods });
  }

  return { allPeriods, pay_sum_alls };
};

export const Credit_Debt = (data, index, age) => {
  let pay_sum_alls = Array.from({ length: age }).fill(0);
  let cardNames =
    data && data.credit_cards
      ? data.credit_cards?.map((item, index) => {
          return {
            name: item && item.creditor_name,
            pay_periods: Array.from({ length: age }).fill(0),
          };
        })
      : [];

  // console.log("data", data);

  data?.map((item2, index2) => {
    const calcPeriodInterest = (index) => {
      let period = item2?.creditor_items?.length;

      let year = Math.floor(period / 12);
      let lastYearMonth = period % 12;

      if (index >= Math.ceil(period / 12)) {
        return 0;
      }
      if (index < year) {
        return 12;
      } else {
        return lastYearMonth;
      }
    };
    if (
      item2?.type_payment === "pay_minimum" ||
      item2?.type_payment === "pay_other"
    ) {
      pay_sum_alls[index2] += item2?.creditor_items
        ?.slice(12 * index2, 12 * (index2 + 1))
        ?.reduce((acc, item) => {
          return acc + item?.total_min;
        }, 0);
    }

    if (item2?.type_payment === "pay_full" && index2 === 0) {
      if (index2 === 0) {
        return (pay_sum_alls[index2] += item2?.pay_peryear);
      }
      return (pay_sum_alls[index2] +=
        item2?.pay_permonth * calcPeriodInterest(index2));
    }
  });

  return { allPeriods: cardNames, pay_sum_alls };
};

/**
 * สร้างผลลัพธ์กระแสเงินสดจากข้อมูลต้นทางของแผนทุกครั้ง
 * เพื่อไม่ให้ cash flow เก่าที่บันทึกไว้เป็นตัวตัดรายได้ประจำในปีถัดไป
 */
export const CalcAll_Expense = (
  tempFutureData,
  balanceData,
  educationData,
  key_under_education
) => {
  let copytempFutureData = tempFutureData;
  const existingIncomeDuration = resolveExistingIncomeDuration({
    duration: tempFutureData?.salary_peryear_duration,
    isExplicit:
      tempFutureData?.salary_peryear_duration_is_explicit === true,
    ageCurrent: tempFutureData?.age_current,
    ageRetire: tempFutureData?.age_retire,
  });
  const salarySource = tempFutureData?.salary;
  const hasSalarySource =
    salarySource !== null &&
    salarySource !== undefined &&
    salarySource !== "" &&
    Number.isFinite(Number(salarySource));
  const salaryPerYear = Number(salarySource || 0) * 12;
  const salaryGrowthRate =
    Number(tempFutureData?.salary_peryear || 0) / 100;

  let carExpense = [...tempFutureData?.expenese_car_items || []];
  let homeExpense = [...tempFutureData?.expenese_home_items || []];
  let childExpense = [...tempFutureData?.expenese_children_items || []];
  let travelExpense = [...tempFutureData?.expenese_travel_items || []];
  let collectionExpense = [...tempFutureData?.expenese_collection_items || []];
  let otherExpense = [...tempFutureData?.expenese_other_items || []];


  // =======รายรับ===========================

  //----------"มรดก"------------
  let incomeLegacyItems = tempFutureData?.income_legacy_items;
  //----------ขายธุรกิจ------------
  let incomeBusinessItems = tempFutureData?.income_business_items;

  //----------รายรับจากอสังหาริม------------
  let incomePropertyItems = tempFutureData?.income_property_items;

  //-------รายรับอื่นๆ----------
  let incomeOtherItems = tempFutureData?.income_other_items;

  // ========หนี้=============================

  // หนี้ดอกลอย
  let debtShortList = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_shortterm_other"
  )?.short_term_others;

  // หนี้ีนอกระบบ
  let debtInformalShortterm = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_informal_shortterm"
  )?.informal_short_terms;

  // เงินกู้ระยะสั้น
  let debtShortTerm = balanceData?.debt_short_list?.find(
    (item) => item?.options_debt_short === "debt_shortterm"
  )?.short_terms;

  // บัตรเครดิต
  let debtCreditcard = balanceData?.debt_short_list
    ?.find((item) => item?.options_debt_short === "debt_creditcard")
    ?.credit_cards?.map((item2, index2) => {
      let tempCalDebtCreditCard = calDebtCreditCard(item2);

      tempCalDebtCreditCard.creditor_name = item2?.creditor_name;
      tempCalDebtCreditCard.type_payment = item2?.type_payment;
      tempCalDebtCreditCard.pay_peryear = item2?.pay_peryear;
      tempCalDebtCreditCard.pay_permonth = item2?.pay_permonth;
      return tempCalDebtCreditCard;
    });

  // ========หนี้ระยะยาว=============================

  // หนี้ระยะยาว รถ
  let debtCar = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_car"
  )?.debt_long_cars;

  // หนี้ระยะยาว บ้าน
  let debtPlace = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_place"
  )?.debt_long_places;

  // หนี้ระยะยาว อื่นๆ
  let debtLongOther = balanceData?.debt_long_list?.find(
    (item) => item?.options_debt_long === "debt_long_other"
  )?.debt_long_others;

  // คำนวณรายจ่าย
  let newTempData = tempFutureData?.cash_flow_items?.map((itemA, indexA) => {
    let newItem = itemA;

    newItem.outcome_total =
      Number(newItem?.out_come_stable || 0) +
      Number(newItem?.outcome_peryear || 0);

    carExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
      if (itemB?.year + itemB?.period_year > indexA && itemB?.year <= indexA) {
        newItem.outcome_total =
          itemB?.pay_per_year * 12 + newItem?.outcome_total;
      }
    });

    homeExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
      if (itemB?.year + itemB?.period_year > indexA && itemB?.year <= indexA) {
        newItem.outcome_total =
          itemB?.pay_per_year * 12 + newItem?.outcome_total;
      }
    });

    childExpense?.map((itemB, indexB) => {
      if (itemB?.ishasEducation) {
        if (itemB?.year > indexA) {
          return (newItem.outcome_total += itemB?.sum_invest_five);
        }

        if (itemB?.year - 1 < indexA && itemB?.year + 22 > indexA) {
          let eduExpense =
            Education_Price?.[indexA - itemB?.year]?.[itemB?.education_under] *
            Math.pow(1.05, indexA - 1);

          return (newItem.outcome_total += eduExpense * Math.pow(1.05, indexA));
        }

        return (newItem.outcome_total += 0);
      }

      if (itemB?.year - 1 > indexA) {
        return (newItem.outcome_total += itemB?.sum_invest_five);
      }

      return (newItem.outcome_total += 0);
    });

    travelExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
    });

    collectionExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
    });

    otherExpense?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        newItem.outcome_total = itemB?.sum_invest_five + newItem?.outcome_total;
      }
    });

    //----------"การศึกษาบุตร"------------

    educationData?.map((itemB, indexB) => {
      if (tempFutureData?.expenese_children_education?.length > 0) {
        newItem.outcome_total += Number(
          itemB?.education_items[indexA]?.sum_under_education || 0
        );
        return;
      }
    });

    // tempFutureData?.cash_flow_items

    // ========หนี้=============================

    // หนี้ดอกลอย
    debtShortList?.map((itemB, indexB) => {
      let year = Math.floor(itemB?.period / 12);
      let lastYearMonth = itemB?.period % 12;

      if (indexA >= Math.ceil(itemB?.period / 12)) {
        newItem.outcome_total += 0;
      }
      if (indexA < year) {
        newItem.outcome_total += itemB?.pay_permonth * 12;
      } else {
        newItem.outcome_total += itemB?.pay_permonth * lastYearMonth;
      }
    });

    // หนี้ีนอกระบบ
    debtInformalShortterm?.map((item2, index2) => {
      let year = Math.floor(item2?.number_of_days / 365);
      let lastYearMonth = item2?.number_of_days % 30;

      if (item2?.period === "Infinity") {
        newItem.outcome_total += item2?.pay_permonth * 12;
      } else {
        if (indexA >= Math.ceil(item2?.number_of_days / 365)) {
          newItem.outcome_total += 0;
        } else {
          if (indexA < year) {
            newItem.outcome_total += item2?.pay_permonth * 365;
          } else {
            newItem.outcome_total += item2?.pay_permonth * lastYearMonth;
          }
        }
      }
    });

    // เงินกู้ระยะสั้น
    debtShortTerm?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (item2?.period === "Infinity") {
        newItem.outcome_total += item2?.pay_permonth * 12;
      } else {
        if (indexA >= Math.ceil(item2?.number_of_days / 365)) {
          newItem.outcome_total += 0;
        } else {
          if (indexA >= Math.ceil(item2?.period / 12)) {
            newItem.outcome_total += 0;
          } else {
            if (indexA < year) {
              newItem.outcome_total += item2?.pay_permonth * 12;
            } else {
              newItem.outcome_total += item2?.pay_permonth * lastYearMonth;
            }
          }
        }
      }
    });

    // บัตรเครดิต
    debtCreditcard?.map((item2, index2) => {
      let period = calDebtCreditCard(item2)?.creditor_items?.length;
      let year = Math.floor(period / 12);
      let lastYearMonth = period % 12;
      const calcPeriodInterest = (index) => {
        let period = item2?.creditor_items?.length;

        let year = Math.floor(period / 12);
        let lastYearMonth = period % 12;

        if (index >= Math.ceil(period / 12)) {
          return 0;
        }
        if (index < year) {
          return 12;
        } else {
          return lastYearMonth;
        }
      };

      if (
        item2?.type_payment === "pay_minimum" ||
        item2?.type_payment === "pay_other"
      ) {
        newItem.outcome_total += item2?.creditor_items
          ?.slice(12 * indexA, 12 * (indexA + 1))
          ?.reduce((acc, item) => {
            return acc + item?.total_min;
          }, 0);
      }

      if (item2?.type_payment === "pay_full" && indexA === 0) {
        if (indexA === 0) {
          return (newItem.outcome_total += item2?.pay_peryear);
        }
        return (newItem.outcome_total +=
          item2?.pay_permonth * calcPeriodInterest(index2));
      }
    });

    // // ========หนี้ระยะยาว=============================
    // หนี้ระยะยาว รถ
    debtCar?.map((item2, index2) => {
      let year = Math.floor(item2?.period / 12);
      let lastYearMonth = item2?.period % 12;

      if (indexA >= Math.ceil(item2?.period / 12)) {
        return (newItem.outcome_total += 0);
      }
      if (indexA < year) {
        return (newItem.outcome_total += item2?.pay_permonth * 12);
      } else {
        return (newItem.outcome_total += item2?.pay_permonth * lastYearMonth);
      }
    });

    // หนี้ระยะยาว บ้าน
    debtPlace?.map((item2, index2) => {
      const tempPeriod = item2?.period * 12;
      let year = Math.floor(tempPeriod / 12);
      let lastYearMonth = tempPeriod % 12;

      if (indexA >= Math.ceil(tempPeriod / 12)) {
        return (newItem.outcome_total += 0);
      }
      if (indexA < year) {
        return (newItem.outcome_total += item2?.pay_permonth * 12);
      } else {
        return (newItem.outcome_total += item2?.pay_permonth * lastYearMonth);
      }
    });

    // หนี้ระยะยาว อื่นๆ
    debtLongOther?.map((item2, index2) => {
      const tempPeriod = item2?.period * 12;
      let year = Math.floor(tempPeriod / 12);
      let lastYearMonth = tempPeriod % 12;

      if (indexA >= Math.ceil(tempPeriod / 12)) {
        return (newItem.outcome_total += 0);
      }
      if (indexA < year) {
        return (newItem.outcome_total += item2?.pay_permonth * 12);
      } else {
        return (newItem.outcome_total += item2?.pay_permonth * lastYearMonth);
      }
    });

    return newItem;
  });

  // คำนวณรายรับ
  newTempData?.map((itemA, indexA) => {
    let newItem = itemA;
    const itemAge = Number(itemA?.age);
    const ageRetire = Number(tempFutureData?.age_retire);

    if (
      hasSalarySource &&
      Number.isFinite(itemAge) &&
      Number.isFinite(ageRetire) &&
      itemAge <= ageRetire
    ) {
      newItem.income_peryear =
        salaryPerYear * Math.pow(1 + salaryGrowthRate, indexA);
    }

    // รายรับอื่นๆหลัก
    newItem.other_income =
      tempFutureData?.other_income *
      Math.pow(1 + (tempFutureData?.other_income_growth || 0) / 100, indexA);

    if (existingIncomeDuration <= indexA) {
      newItem.other_income = 0;
    }

    if (itemAge > ageRetire) {
      newItem.income_peryear = itemA?.pension_peryear;
    }

    newItem.total_income = Number(newItem.income_peryear || 0) + Number(newItem.other_income*12 || 0);


    //----------"มรดก"------------
    incomeLegacyItems?.map((itemB, indexB) => {
      if (itemB?.year === indexA) {
        return (newItem.total_income += itemB?.amount);
      }
    });

    //----------ขายธุรกิจ------------
    incomeBusinessItems?.map((itemB, indexB) => {
      if (itemB?.year === indexA) {
        return (newItem.total_income += itemB?.amount);
      }
    });

    //----------รายรับจากอสังหาริม------------
    incomePropertyItems?.map((itemB, indexB) => {
      if (itemB?.is_rent) {
        if (itemB?.year > indexA) {
          return (newItem.total_income += 0);
        }
        if (itemB?.year <= indexA && itemB?.year + itemB?.year_rent > indexA) {
          return (newItem.total_income += itemB?.amount_perYear);
        }
        return (newItem.total_income += 0);
      }

      if (itemB?.year === indexA) {
        return (newItem.total_income += itemB?.amount);
      }
    });

    //-------รายรับอื่นๆ----------
    incomeOtherItems?.map((itemB, indexB) => {
      if (itemB?.year > indexA) {
        return (newItem.total_income += 0);
      }
      if (itemB?.year <= indexA && itemB?.year + itemB?.year_rent > indexA) {
        return (newItem.total_income += itemB?.amount_perYear);
      }
      return (newItem.total_income += 0);
    });


    return newItem;
  });

  

  // คำนวณคงเหลือ
  newTempData?.map((itemA, indexA) => {
    let newItem = itemA;
    newItem.remain =
      Number(itemA?.total_income || 0) - Number(itemA?.outcome_total || 0);

    return newItem;
  });

  // ผลตอบแทนการลงทุน
  // สินทรัพย์ลงทุน

  newTempData?.map((itemA, indexA) => {
    let newItem = itemA;

    if (indexA === 0) {
      newItem.income_investment =
        (tempFutureData?.income_investment *
          tempFutureData?.income_investment_percent) /
        100;

      // ทำให้ตรงกับ sheet เฉยๆ
      newItem.remain_accumulate =
        Math.ceil(
          (Number(newItem?.remain || 0) +
            Number(newItem?.income_investment || 0) +
            Number(tempFutureData?.income_investment || 0)) *
            100
        ) / 100;

      return newItem;
    }

    if (tempFutureData?.age_retire < tempFutureData?.age_current + indexA) {
      newItem.income_investment =
        (newTempData[indexA - 1].remain_accumulate *
          (tempFutureData?.income_investment_percent - 1)) /
        100;

      // ทำให้ตรงกับ sheet เฉยๆ
      newItem.remain_accumulate =
        Math.floor(
          (Number(newItem?.remain || 0) +
            Number(newItem?.income_investment || 0) +
            Number(newTempData[indexA - 1]?.remain_accumulate || 0)) *
            100
        ) / 100;

      return newItem;
    }

    // ทำให้ตรงกับ sheet เฉยๆ
    newItem.income_investment =
      (newTempData[indexA - 1].remain_accumulate *
        tempFutureData?.income_investment_percent) /
      100;

    newItem.remain_accumulate =
      Math.floor(
        (Number(newItem?.remain || 0) +
          Number(newItem?.income_investment || 0) +
          Number(newTempData[indexA - 1]?.remain_accumulate || 0)) *
          100
      ) / 100;

    return newItem;
  });

  return newTempData;
};

export const calExpensesDefaultValueFuture = (
  year,
  educationLabel,
  under_education,
  custom_under_education,
  inflationrate = 5,
  moreYear = 0
) => {
  // console.log("educationLabel", educationLabel)
  // console.log("under_education", under_education)

  const findEducationLists =
    under_education === "custom"
      ? Education_Price?.find((item) => item.type === String(educationLabel))?.[
          custom_under_education
        ]
      : Education_Price?.find((item) => item.type === String(educationLabel))?.[
          under_education
        ];

  const inflation_amount = inflationrate / 100;
  const date = new Date();

  const moreYearCheck = typeof moreYear === "number" ? moreYear : 0;
  const infaltionYear = moreYearCheck + date.getFullYear() + 543 - 2566;

  const startValue =
    findEducationLists * Math.pow(1 + inflation_amount, infaltionYear);

  let sum = 0;

  // console.log("findEducationLists",findEducationLists)
  // console.log("inflation_amount", inflation_amount);
  // // console.log("infaltionYear", infaltionYear);
  // console.log("moreYear",moreYear)
  // console.log("startValue",  Math.pow(1 + inflation_amount, infaltionYear));

  // =ROUNDUP(L3*(1+0.06)^(N2-1))
  sum = startValue * Math.pow(1 + inflation_amount, year - 1);

  return sum;
};

export const CalcAllChildExpense = (
  childExpense,
  futurePlanData,
  indexFirst,
  education_under,
  choice_value
) => {
  // console.log("childExpense", childExpense)
  // console.log("futurePlanData", futurePlanData)
  // console.log("indexFirst", indexFirst)
  // console.log("education_under",education_under)
  // console.log("choice_value",choice_value)

  let newTempData = futurePlanData?.cash_flow_items?.map((itemA, indexA) => {
    let newItem = itemA;
    newItem.outcome_total = 0;

    if (education_under === choice_value) {
      if (
        indexA > childExpense[indexFirst]?.year &&
        indexA < childExpense[indexFirst]?.year + 22
      ) {
        let eduExpense = Math.ceil(
          calExpensesDefaultValueFuture(
            indexA - childExpense[indexFirst]?.year,
            Education_Price[indexA - childExpense[indexFirst]?.year]?.type,
            education_under,
            education_under,
            6,
            childExpense[indexFirst]?.year
          )
        );

        // console.log("eduExpense", eduExpense)

        return eduExpense;

        // return (newItem.outcome_total +=
        //   eduExpense * Math.pow(1.06, indexA - childExpense[indexFirst]?.year));
      }

      return (newItem.outcome_total += 0);
    }
  });

  // console.log("newTempData", newTempData)

  // console.log("-------------------")

  return newTempData?.reduce((total, number) => total + number, 0);
};
